import { HttpParams } from '@angular/common/http';

import { toHTTPParam } from '../../../../core';
import { periodicidadeMensal } from '../integration-periodicidade';

export class IntegrationPedido {
    periodicidade: number;
    dataInicialBase: Date;
    execReadAndUpdateIntegration: boolean; // Executar integração de leitura e de leitura de atualização dos pedidos
    execReadIntegrationErp: boolean; // Executar integração de leitura dos pedidos lançados no ERP

    constructor() {
        this.periodicidade = periodicidadeMensal.id;
        this.execReadAndUpdateIntegration = true;
        this.execReadIntegrationErp = true;
    }

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Periodicidade
        if (this.periodicidade) {
            params = params.append('periodicidade', this.periodicidade.toString());
        }
        // Data Inicial Base
        if (this.dataInicialBase) {
            params = params.append('dataInicialBase', toHTTPParam(this.dataInicialBase));
        }
        // Executar integração de leitura e de leitura de atualização dos pedidos
        if (this.execReadAndUpdateIntegration) {
            params = params.append('execReadAndUpdateIntegration', this.execReadAndUpdateIntegration.toString());
        }
        // Executar leitura dos pedidos lançados no ERP
        if (this.execReadIntegrationErp) {
            params = params.append('execReadIntegrationErp', this.execReadIntegrationErp.toString());
        }

        return params;
    }

    clear() {
        this.periodicidade = periodicidadeMensal.id;
        this.dataInicialBase = null;
        this.execReadAndUpdateIntegration = true;
        this.execReadIntegrationErp = true;
    }
}
